export default __webpack_public_path__ + "static/media/graphic.789642af.mp4";